// @flow

import _ from "lodash";
// import ReactDOM from "react-dom";

import { createToolbarEvent, sendAnalytics } from "../../analytics";
import { appNavigate } from "../../app/actions";
import { disconnect } from "../../base/connection";
import { translate } from "../../base/i18n";
import { connect } from "../../base/redux";
import { AbstractHangupButton } from "../../base/toolbox/components";
import type { AbstractButtonProps } from "../../base/toolbox/components";
import { baseUrl } from "../../../api";
import { render } from "react-dom";
/**
 * The type of the React {@code Component} props of {@link HangupButton}.
 */
type Props =
    | AbstractButtonProps
    | {
          /**
           * The redux {@code dispatch} function.
           */
          dispatch: Function,
          conference: Object,

          _isModeratorCheckAhmad: Object,
          count: number,
      };

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractHangupButton<Props, *> {
    _hangup: Function;

    accessibilityLabel = "toolbar.accessibilityLabel.hangup";
    label = "toolbar.hangup";
    tooltip = "toolbar.hangup";

    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);
        
        this._hangup = _.once(() => {
            sessionStorage.setItem("participantIsUser", true);

            localStorage.removeItem("meeting_id");
            localStorage.removeItem("notes");
            localStorage.removeItem("isModerator");
            localStorage.removeItem("sessionId");
            sendAnalytics(createToolbarEvent("hangup"));
            // window.top.close();
            window.location.replace("/");
            return;

            //FIXME: these should be unified.
            if (navigator.product === "ReactNative") {
                this.props.dispatch(appNavigate(undefined));
            } else {
                this.props.dispatch(disconnect(true));
            }
        });
    }
    // componentDidUpdate(prevProps) {
    //   const { _isModeratorCheckAhmad } = this.props;

    //   // Compare previous _isModeratorCheckAhmad with current _isModeratorCheckAhmad
    //   if (_isModeratorCheckAhmad?.isModerators?.value !== prevProps._isModeratorCheckAhmad?.isModerators?.value) {
    //     // React to changes in _isModeratorCheckAhmad
    //     if (_isModeratorCheckAhmad.isModerators.value) {
    //       console.log("Moderator addedinhang");
    //       // sessionStorage.removeItem("participantIsUser");

    //       // this.setState({
    //       //   openNotesBtn: true,
    //       //   showNotes: false,
    //       // });
    //     } else {
    //       // React to the case where the value becomes false
    //       console.log("Moderator removed");
    //       // Perform any other necessary actions
    //     }
    //   }
    // }
    addMeetingNotes() {
        // let isModerator = sessionStorage.getItem("terminate");
        // console.log("isModerator", isModerator);
        let payload = {
            notes: localStorage.getItem("notes") || "",
            duration: localStorage.getItem("time"),
            // meeting_id: localStorage.getItem("meeting_id")
            //     ? localStorage.getItem("meeting_id")
            //     : window.location.pathname.substring(
            //           window.location.pathname.lastIndexOf("/") + 1
            //       ),
            meeting_id: sessionStorage.getItem("meeting_name")
        };

        fetch(`${baseUrl}/add_meeting_note_n`, {
            method: "POST", // or 'PUT'
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                let isModerator = sessionStorage.getItem("terminate");
               // console.log("isModerator", isModerator);
                if (!isModerator) {
                    sessionStorage.setItem("terminatePage", true);
                }
                sessionStorage.removeItem("isModerator");
                localStorage.removeItem("meeting_id");
                localStorage.removeItem("notes");
                localStorage.removeItem("isModerator");
                localStorage.removeItem("terminate");
                localStorage.removeItem("sessionId");
                sendAnalytics(createToolbarEvent("hangup"));
                window.top.close();
                window.close();
                window.location.replace("/");

                // this._hangup();
            })
            .catch((error) => {
                window.close();
                this._hangup();
                console.error("Error:", error);
            });
    }

    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        const val = sessionStorage.getItem("isModerator");
        if (val == "true") {
            this.addMeetingNotes();
        } else {
            this._hangup();
        }
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code ParticipantsCount} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    //console.log("mapStateToPropsyes", state);
    return {
        conference: state["features/base/conference"].conference,
        _isModeratorCheckAhmad: state["features/base/participants"],
    };
}
export default translate(connect(mapStateToProps)(HangupButton));
